/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadStampsDto
 */
export interface UploadStampsDto {
    /**
     * Base64 encoded big stamp image
     * @type {string}
     * @memberof UploadStampsDto
     */
    big?: string | null;
    /**
     * Base64 encoded small stamp image
     * @type {string}
     * @memberof UploadStampsDto
     */
    small?: string | null;
    /**
     * Base64 encoded double stamp image
     * @type {string}
     * @memberof UploadStampsDto
     */
    _double?: string | null;
    /**
     * Base64 encoded signature image
     * @type {string}
     * @memberof UploadStampsDto
     */
    signature?: string | null;
}

/**
 * Check if a given object implements the UploadStampsDto interface.
 */
export function instanceOfUploadStampsDto(value: object): value is UploadStampsDto {
    return true;
}

export function UploadStampsDtoFromJSON(json: any): UploadStampsDto {
    return UploadStampsDtoFromJSONTyped(json, false);
}

export function UploadStampsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadStampsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'big': json['big'] == null ? undefined : json['big'],
        'small': json['small'] == null ? undefined : json['small'],
        '_double': json['double'] == null ? undefined : json['double'],
        'signature': json['signature'] == null ? undefined : json['signature'],
    };
}

export function UploadStampsDtoToJSON(value?: UploadStampsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'big': value['big'],
        'small': value['small'],
        'double': value['_double'],
        'signature': value['signature'],
    };
}

